/**
 * Application settings and configuration values
 * Centralized location for all configurable parameters used across the app
 */

const settings = {
  // WhatsApp related links
  wa_group_link: "https://chat.whatsapp.com/En2xvhNfpgcAkOFLBYnurx",
  wa_consultant_link: "https://wa.me/6285136667008", 
  
  // Social media links
  social_media: {
    instagram: "https://instagram.com/pintarpilihkuliah",
    facebook: "https://facebook.com/pintarpilihkuliah",
    youtube: "https://youtube.com/@pintarpilihkuliah",
  },
  
  // Contact information
  contact: {
    email: "info@pilihkuliah.com",
    phone: "+6285136667008",
  },
  
  // Application metadata
  app_name: "#PintarPilihKuliah",
  app_description: "Platform untuk memudahkan alumni pesantren dan pelajar se-Indonesia untuk mengakses peluang pendidikan internasional.",
  
  // Feature flags
  features: {
    enable_blog: true,
    enable_testimonials: true,
    enable_wa_floating_button: true,
  }
};

export default settings;